import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as o}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as C}from"../../icon-registry.js";const r=C("bookmark",o`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.28571 19.6033L12 17.1437L17.7143 19.6033V4.78807H6.28571V19.6033ZM5.6 22.4062C5.21905 22.5588 4.85714 22.5252 4.51429 22.3056C4.17143 22.0867 4 21.7675 4 21.348V4.78807C4 4.15885 4.224 3.62001 4.672 3.17155C5.11924 2.72385 5.65714 2.5 6.28571 2.5H17.7143C18.3429 2.5 18.8811 2.72385 19.3291 3.17155C19.7764 3.62001 20 4.15885 20 4.78807V21.348C20 21.7675 19.8286 22.0867 19.4857 22.3056C19.1429 22.5252 18.781 22.5588 18.4 22.4062L12 19.6605L5.6 22.4062ZM6.28571 4.78807H17.7143H12H6.28571Z"
                fill="#FCFCFC" />
        </svg>
    `),w=C("bookmark_filled",o`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.6 22.4062C5.21905 22.5588 4.85714 22.5252 4.51429 22.3056C4.17143 22.0867 4 21.7675 4 21.348V4.78807C4 4.15885 4.224 3.62001 4.672 3.17155C5.11924 2.72385 5.65714 2.5 6.28571 2.5H17.7143C18.3429 2.5 18.8811 2.72385 19.3291 3.17155C19.7764 3.62001 20 4.15885 20 4.78807V21.348C20 21.7675 19.8286 22.0867 19.4857 22.3056C19.1429 22.5252 18.781 22.5588 18.4 22.4062L12 19.6605L5.6 22.4062Z"
                fill="#FCFCFC" />
        </svg>
    `);export{r as Bookmark,w as BookmarkFilled};
